import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, Checkbox, Grid } from 'semantic-ui-react';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { resetForm } from 'State/forms/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { TRANSFER_ORDER_FORM_NAME } from 'Common/FormEnum';
import { TransferOrderEnum } from 'Common/FieldEnum';
import * as GridPreferenceSelectors from 'State/gridPreference/selectors';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import {
  PrintSortTypeEnum,
  GenericEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { errorToast } from 'Common/ToastHelper';
import { LoadingPage } from 'Components';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { dateSortMethod } from 'Common/GridHelper';

import { actions } from '../../state/actions';
import TransferOrder from '../../components/TransferOrderList/TransferOrder';
import { basicURL, SiteAllEnum } from '../../helper';
import * as TransferOrderListSelectors from '../../state/TransferOrderList/selectors';

import 'Styles/pages/inventory/transaction/transfer/index.less';

class TransferContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    BeginDT: PropTypes.string,
    EndDT: PropTypes.string,
    site: PropTypes.string,
    printOptionsValue: PropTypes.string,
    allTableStates: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    gridPreferenceData: PropTypes.object.isRequired,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    transferOrderListData: PropTypes.array,
    loading: PropTypes.bool,
    printLoading: PropTypes.bool,
    fromDateMax: PropTypes.object,
    toDateMin: PropTypes.object,
    printData: PropTypes.string,
    preferenceJsonError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printLoadingError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    transferOrderListDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };
  static defaultProps = {
    [TransferOrderEnum.BeginDT]: moment()
      .subtract(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    [TransferOrderEnum.EndDT]: moment()
      .add(1, 'month')
      .format(DATE_FORMAT_FOR_UI),
    [TransferOrderEnum.Site]: 'ALL',
    [TransferOrderEnum.PrintOptions]: TransferOrderEnum.ItemCode,
    printData: '',
    transferOrderListData: [],
    fromDateMax: null,
    toDateMin: null,
    printLoading: false,
    loading: false,
  };
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      activeIndexForFilter: 0,
      activeIndexForSort: 0,
      selectedTransfers: [],
      columns: [
        {
          Header: currentRows => {
            const { selectedTransfers } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, obj => {
              const id = obj[TransferOrderEnum.TransferID]
                ? obj[TransferOrderEnum.TransferID]
                : obj._original[TransferOrderEnum.TransferID];
              if (selectedTransfers.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    e.stopPropagation();
                    if (checked) {
                      this.setState({
                        selectedTransfers: [
                          ...this.state.selectedTransfers,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedTransfers];
                      _.forEach(dataObjs, obj => {
                        const id = obj[TransferOrderEnum.TransferID]
                          ? obj[TransferOrderEnum.TransferID]
                          : obj._original[TransferOrderEnum.TransferID];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({ selectedTransfers: copySelected });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: TransferOrderEnum.Allowed,
          ...ReactTableWrapperColumnProperties,
          visibility: false,
          sortable: false,
          filterable: false,
          Cell: ({ original }) => {
            const { selectedTransfers } = this.state;
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    selectedTransfers.indexOf(
                      original[TransferOrderEnum.TransferID]
                    ) !== -1
                  }
                  onChange={(e, { checked }) => {
                    this.checkCurrentRow(original, checked);
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Transfer #',
          accessor: TransferOrderEnum.TransferID,
          className: 'right-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'From Site',
          accessor: TransferOrderEnum.FromSite,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'From Site Name',
          accessor: TransferOrderEnum.FromSiteName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'To Site',
          accessor: TransferOrderEnum.ToSite,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'To Site Name',
          accessor: TransferOrderEnum.ToSiteName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Transfer Date',
          accessor: TransferOrderEnum.TransactionDT,
          sortMethod: dateSortMethod,
          ...ReactTableWrapperColumnProperties,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          Cell: gridProps => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(),
            });
          },
        },
      ],
    };
  }
  checkCurrentRow = (original, checked) => {
    const { selectedTransfers } = this.state;
    let value = [...selectedTransfers];
    checked
      ? value.indexOf(original[TransferOrderEnum.TransferID]) === -1 &&
        value.push(original[TransferOrderEnum.TransferID])
      : value.indexOf(original[TransferOrderEnum.TransferID]) !== -1 &&
        value.splice(value.indexOf(original[TransferOrderEnum.TransferID]), 1);

    this.setState({ selectedTransfers: value });
  };

  onEditClick = row => {
    this.props.history.push(`/transfer/1/${row.TransferID}`);
  };

  componentDidMount() {
    const { BeginDT, EndDT, site } = this.props;
    const Site =
      site === SiteAllEnum.ALL
        ? GenericEnum.InitialFilterValue
        : site
          ? site
          : GenericEnum.InitialFilterValue;
    const filtersOptions = {
      Site,
      DateFrom: BeginDT
        ? moment(BeginDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .subtract(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
      DateTo: EndDT
        ? moment(EndDT).format(DATE_FORMAT_FOR_SERVER)
        : moment()
            .add(1, 'month')
            .format(DATE_FORMAT_FOR_SERVER),
    };
    this.props.getTransferOrderData(filtersOptions);
  }

  componentDidUpdate(prevProps) {
    const { clearTransferGridError, printData } = this.props;
    if (
      errorToast(this.props, prevProps, 'printLoadingError') ||
      errorToast(this.props, prevProps, 'transferOrderListDataError')
    ) {
      clearTransferGridError();
    }
    if (printData && prevProps.printData !== this.props.printData) {
      ReportGeneration(printData, 'Transfer Report');
    }
  }

  componentWillUnmount() {
    this.clearTableSavedState();
    this.setState({ selectedTransfers: [] });
    toast.dismiss();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.TRANSFER_ORDER_TABLE,
      TableNamesEnum.TRANSFER_ITEM_TABLE,
    ]);
  };

  onChangeOfFromDT = (e, beginDate, prevBeginDate) => {
    beginDate !== prevBeginDate && this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate, prevEndDate) => {
    endDate !== prevEndDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    const Site =
      this.props.site === SiteAllEnum.ALL
        ? GenericEnum.InitialFilterValue
        : this.props.site;
    const endDT = this.props[TransferOrderEnum.EndDT];
    this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDate, endDT, Site);
    this.setState({ selectedTransfers: [] });
  };

  selectToDate = (e, endDate) => {
    const Site =
      this.props.site === SiteAllEnum.ALL
        ? GenericEnum.InitialFilterValue
        : this.props.site;
    const beginDT = this.props[TransferOrderEnum.BeginDT];
    this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    this.getFilterData(beginDT, endDate, Site);
    this.setState({ selectedTransfers: [] });
  };

  setSelectedSite = selectedSite => {
    const Site =
      this.props.site === SiteAllEnum.ALL
        ? GenericEnum.InitialFilterValue
        : this.props.site;
    const selectedSiteCopy =
      selectedSite === SiteAllEnum.ALL
        ? GenericEnum.InitialFilterValue
        : selectedSite;
    if (selectedSiteCopy !== Site) {
      const beginDT = this.props[TransferOrderEnum.BeginDT];
      const endDT = this.props[TransferOrderEnum.EndDT];

      if (beginDT && endDT) {
        const filtersOptions = {
          Site: selectedSiteCopy,
          DateFrom: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
          DateTo: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        };
        this.setState({ selectedTransfers: [] });
        this.props.getTransferOrderData(filtersOptions);
      }
    }
  };

  printTransfers = () => {
    const { transferOrderListData, printOptionsValue } = this.props;
    const beginDT = this.props[TransferOrderEnum.BeginDT];
    const endDT = this.props[TransferOrderEnum.EndDT];
    const checkedTransferOrders = this.getFilteredSelectedTransfer();
    const dataObjs =
      this.reactTable && this.reactTable.current
        ? this.reactTable.current.getResolvedState()
        : { sortedData: transferOrderListData };
    if (
      checkedTransferOrders &&
      !checkedTransferOrders.length &&
      dataObjs.sortedData.length
    ) {
      checkedTransferOrders[0] =
        dataObjs.sortedData[0][TransferOrderEnum.TransferID];
    }
    const DateFrom = moment(beginDT).format(DATE_FORMAT_FOR_SERVER);
    const DateTo = moment(endDT).format(DATE_FORMAT_FOR_SERVER);
    let sortType =
      printOptionsValue === TransferOrderEnum.ItemCode
        ? PrintSortTypeEnum.ItemCode
        : PrintSortTypeEnum.ItemDescription;

    checkedTransferOrders.length &&
      this.props.getPrintTransferData({
        DateFrom,
        DateTo,
        SortType: sortType,
        TransferIds: checkedTransferOrders,
      });
  };

  clearFilters = () => {
    const { initialValues } = this.props;
    this.props.setFromDateMax(moment().add(1, 'month'));
    this.props.setToDateMin(moment().subtract(1, 'month'));
    this.setState({ selectedTransfers: [] });
    this.getFilterData(
      initialValues[TransferOrderEnum.BeginDT],
      initialValues[TransferOrderEnum.EndDT],
      GenericEnum.InitialFilterValue
    );
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(TRANSFER_ORDER_FORM_NAME);
  };

  getFilterData = (DateFrom, DateTo, Site) => {
    if (DateFrom && DateTo) {
      const filtersOptions = {
        Site,
        DateFrom: moment(DateFrom).format(DATE_FORMAT_FOR_SERVER),
        DateTo: moment(DateTo).format(DATE_FORMAT_FOR_SERVER),
      };
      this.props.getTransferOrderData(filtersOptions);
    }
  };
  getMenuOptions = () => {
    let checkCount = _.filter(
      this.props.transferOrderListData,
      TransferOrderEnum.Allowed
    );

    if (checkCount.length <= 1)
      return [
        {
          icon: 'eye',
          text: 'View',
          handler: this.onEditClick,
        },
      ];

    return [];
  };

  onAddClick = () => {
    this.props.history.push('/transfer/0/0');
  };

  handleClick = (e, titleProps) => {
    const { index, option } = titleProps;
    const { activeIndexForFilter, activeIndexForSort } = this.state;
    const newIndex = !option
      ? activeIndexForFilter === index
        ? -1
        : index
      : activeIndexForSort === index
        ? -1
        : index;
    !option
      ? this.setState({
          activeIndexForFilter: newIndex,
        })
      : this.setState({
          activeIndexForSort: newIndex,
        });
  };
  getFilteredSelectedTransfer = () => {
    const { transferOrderListData } = this.props;
    const { selectedTransfers } = this.state;
    const checkedUsageOrders = [];
    const dataObjs =
      this.reactTable && this.reactTable.current
        ? this.reactTable.current.getResolvedState()
        : { sortedData: transferOrderListData };
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[TransferOrderEnum.TransferID]
        ? obj[TransferOrderEnum.TransferID]
        : obj._original[TransferOrderEnum.TransferID];
      if (selectedTransfers.indexOf(id) !== -1) {
        checkedUsageOrders.push(id);
      }
    });
    return checkedUsageOrders;
  };

  render() {
    const {
      transferOrderListData,
      gridPreferenceSubmitting,
      gridPreferenceLoading,
      loading,
      printLoading,
      fromDateMax,
      toDateMin,
      site,
    } = this.props;
    const { activeIndexForFilter, activeIndexForSort } = this.state;

    return printLoading ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Transfers'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <TransferOrder
            transferOrderListData={transferOrderListData}
            columns={this.state.columns}
            reactTableRef={this.reactTable}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            gridPreferenceLoading={gridPreferenceLoading}
            loading={loading}
            printLoading={printLoading}
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            onChangeOfToDT={this.onChangeOfToDT}
            toDateMin={toDateMin}
            setSelectedSite={this.setSelectedSite}
            clearFilters={this.clearFilters}
            printTransfers={this.printTransfers}
            activeIndexForFilter={activeIndexForFilter}
            activeIndexForSort={activeIndexForSort}
            handleClick={this.handleClick}
            siteValue={site}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(TRANSFER_ORDER_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(TRANSFER_ORDER_FORM_NAME)(state));

  return {
    [TransferOrderEnum.BeginDT]: selector(state, TransferOrderEnum.BeginDT),
    [TransferOrderEnum.EndDT]: selector(state, TransferOrderEnum.EndDT),
    site: selector(state, TransferOrderEnum.Site),
    printOptionsValue: selector(state, TransferOrderEnum.PrintOptions),
    allTableStates: getTableStates(state),
    initialValues: {
      [TransferOrderEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [TransferOrderEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [TransferOrderEnum.Site]: 'ALL',
      [TransferOrderEnum.PrintOptions]: TransferOrderEnum.ItemCode,
    },

    gridPreferenceData: GridPreferenceSelectors.getPreferenceJson(state),
    gridPreferenceSubmitError: GridPreferenceSelectors.getSubmitError(state),
    gridPreferenceLoading: GridPreferenceSelectors.getLoading(state),
    gridPreferenceSubmitting: GridPreferenceSelectors.getIsSubmitting(state),
    preferenceJsonError: GridPreferenceSelectors.getPreferenceJsonError(state),

    transferOrderListData: TransferOrderListSelectors.getTransferOrderListData(
      state
    ),
    loading: TransferOrderListSelectors.getLoading(state),
    printLoading: TransferOrderListSelectors.getPrintLoading(state),
    printLoadingError: TransferOrderListSelectors.getPrintLoadingError(state),
    transferOrderListDataError: TransferOrderListSelectors.getTransferOrderListDataError(
      state
    ),
    fromDateMax: TransferOrderListSelectors.getFromDateMax(state),
    toDateMin: TransferOrderListSelectors.getToDateMin(state),
    printData: TransferOrderListSelectors.getPrintData(state),
  };
};

const mapDispatchToProps = {
  ...actions,
  resetForm,
  setTableStates,
};
TransferContainer = reduxForm({
  destroyOnUnmount: false,
  form: TRANSFER_ORDER_FORM_NAME,
})(TransferContainer);

export const Transfer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/containers/transferOrderList/TransferContainer.js